import React, { useEffect } from 'react';

import moment from 'moment';
import Modal from 'react-bootstrap/Modal';
import { useForm } from 'react-hook-form';
import Swal from 'sweetalert2';

import strings from '../../Helpers/StringsHelpers';

import { setMaintenanceWarning } from '../Api/Api';

const MassTreatmentModal = ({
  show,
  handleClose,
  selectedNCs = [],
  onSuccess = null,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    Swal.fire({
      didOpen: async () => {
        Swal.showLoading();

        const userId = sessionStorage.getItem('gestao_userId');

        const postDataArray = selectedNCs.map((ncId) => ({
          maintenanceWarningText: data.maintenanceWarningText,
          maintenanceWarningContact: data.maintenanceWarningContact,
          dtRecurrence: data.dtRecurrence,
          systemMaintenanceId: ncId.system_maintenance_id,
          userId: userId,
        }));

        const result = await setMaintenanceWarning(postDataArray);

        if (result?.data?.data === 'successall') {
          Swal.fire({
            title: 'Tratativas incluídas com sucesso!',
            text: `${selectedNCs.length} NCs foram tratadas com sucesso`,
            icon: 'success',
            confirmButtonText: 'Ok',
            confirmButtonColor: '#3085d6',
            allowOutsideClick: false,
            allowEscapeKey: false,
          }).then(() => {
            reset();
            if (typeof onSuccess === 'function') onSuccess();
            handleClose();
          });
        } else {
          Swal.fire(
            'OPS!',
            strings.OCORREU_UM_ERRO_AO_TENTAR_PROCESSAR_ESSA_REQUISICAO,
            'error'
          ).then(() => {
            handleClose();
          });
        }
      },
    });
  };

  useEffect(() => {}, [show, selectedNCs]);

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Tratativa em massa ({selectedNCs.length} NCs)</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            <div className="col-12 mb-3">
              <div className="form-floating">
                <textarea
                  className="form-control"
                  placeholder="Descrição *"
                  aria-label="Descrição *"
                  {...register('maintenanceWarningText', { required: true })}
                ></textarea>
                <label>
                  Descrição <span className="text-danger">*</span>
                </label>
              </div>
              {errors.maintenanceWarningText?.type === 'required' && (
                <div className="text-danger">
                  <small>{strings.CAMPO_OBRIGATORIO}</small>
                </div>
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-8 mb-3">
              <div className="form-floating">
                <input
                  className="form-control"
                  placeholder="Nome do encarregado *"
                  aria-label="Nome do Encarregado *"
                  {...register('maintenanceWarningContact', { required: true })}
                ></input>
                <label>
                  Nome do encarregado <span className="text-danger">*</span>
                </label>
              </div>
              {errors.maintenanceWarningContact?.type === 'required' && (
                <div className="text-danger">
                  <small>{strings.CAMPO_OBRIGATORIO}</small>
                </div>
              )}
            </div>
            <div className="col-4 mb-3">
              <div className="form-floating">
                <input
                  type="date"
                  min={moment().format('YYYY-MM-DD')}
                  className="form-control"
                  placeholder="Próxima recorrência"
                  aria-label="Próxima recorrência"
                  {...register('dtRecurrence')}
                ></input>
                <label>Próxima recorrência</label>
              </div>
            </div>
          </div>
          <div className="col-12">
            <button type="submit" className="btn btn-success float-end">
              Adicionar
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default MassTreatmentModal;
